import { Controller } from "@hotwired/stimulus"
import { createRoot } from 'react-dom/client';
import React from 'react';

import { ResourceImportEditGrid } from "@/components/resourceImportEditGrid"
import { ImportRow } from "@/components/resourceImportEditGrid/types";
import { i18n } from "../lib/i18n"

export default class extends Controller {
  static targets = ["spinner"]
  static values = {
    id: String,
    qualifications: Array,
    services: Array,
    importUrl: String
  }

  private pollInterval: number | undefined
  private root: any
  private idValue: string
  private qualificationsValue: Array<any>
  private servicesValue: Array<any>
  private importUrlValue: string

  connect() {
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  private startPolling() {
    this.pollInterval = window.setInterval(() => {
      this.checkResourceImport()
    }, 5000) // Poll every 5 seconds

    this.checkResourceImport()
  }

  private stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
    }
  }

  private async checkResourceImport() {
    try {
      const response = await fetch(`${this.importUrlValue}`)
      if (!response.ok) {
        throw new Error('Failed to fetch resource import')
      }
      const data = await response.json()

      if (data.parsed_data?.data && Object.keys(data.parsed_data.data).length > 0) {
        this.stopPolling()
        this.renderGrid(data)
      }
    } catch (error) {
      this.stopPolling()
      console.error('Error polling resource import:', error)
      this.renderError()
    }
  }

  private renderGrid(resourceImport: ResourceImport) {
    this.element.innerHTML = ''
    this.root = createRoot(this.element)
    this.root.render(React.createElement(ResourceImportEditGrid, {
      data: resourceImport.parsed_data,
      qualifications: this.qualificationsValue,
      services: this.servicesValue
    }))
  }

  private renderError() {
    this.element.innerHTML = i18n.t('resource_import_edit.error_checking_status')
  }
}

interface ResourceImport {
  parsed_data: {
    data: ImportRow[]
  }
}
